import { getSessionAuthentication, baseUrl } from '../common/Api';

interface FetchOptions {
    method: string;
    headers: Record<string, string>;
    body?: string;
}

function getHeaders(): Record<string, string> {
    const auth = getSessionAuthentication();
    return {
        'Content-Type': 'application/json',
        'Authorization': auth.token,
        'x-cleverapps-tenant': auth.tenantStringIdentifier,
    };
}

async function legacyFetch<T>(path: string, options?: Partial<FetchOptions>): Promise<T> {
    const response = await fetch(baseUrl + path, {
        method: options?.method ?? 'GET',
        headers: getHeaders(),
        body: options?.body,
    });
    if (!response.ok) {
        const text = await response.text();
        let message = `API error: ${response.status} ${response.statusText}`;
        try {
            const parsed = JSON.parse(text);
            if (parsed?.message) message = parsed.message;
        } catch { /* ignore */ }
        throw new Error(message);
    }
    const text = await response.text();
    return text ? JSON.parse(text) : null;
}

export interface ReturnReason {
    id: number;
    code: string;
    name: string;
    adjustStock: boolean;
    stockLocationId: number | null;
}

export interface Location {
    id: number;
    locationName: string;
}

export async function getReturnReason(id: number): Promise<ReturnReason> {
    return legacyFetch<ReturnReason>(`returnreasons/${id}`);
}

export async function createReturnReason(rr: Partial<ReturnReason>): Promise<ReturnReason> {
    return legacyFetch<ReturnReason>('returnreasons', {
        method: 'POST',
        body: JSON.stringify(rr),
    });
}

export async function updateReturnReason(rr: ReturnReason): Promise<ReturnReason> {
    return legacyFetch<ReturnReason>(`returnreasons/${rr.id}`, {
        method: 'PUT',
        body: JSON.stringify(rr),
    });
}

export async function deleteReturnReason(id: number): Promise<void> {
    await legacyFetch<void>(`returnreasons/${id}`, { method: 'DELETE' });
}

export async function getLocations(): Promise<Location[]> {
    return legacyFetch<Location[]>('returnreasons/locations');
}
